export const SOURCE_METADATA = [
  "type",
  "platform",
  "reliability",
  "misinfoSusceptibility",
  "language",
  "countryOfOrigin",
  "countryOfFocus",
  "socialAuthenticity",
  "followerCountBracket",
];

const formatSourceMetadata = (items) =>
  items.map(({ text, value = text.toLowerCase() }) => ({
    text,
    value,
    count: 0,
    displayText: text,
  }));

export const SOURCE_METADATA_TYPE = formatSourceMetadata([
  { text: "Academic/Think Tank", value: "academic/think tank" },
  { text: "Activist/Extremist", value: "activist/extremist" },
  { text: "Forum" },
  { text: "Humanitarian" },
  { text: "Journalistic" },
  { text: "Labor Union", value: "labor union" },
  { text: "Official/Government", value: "official/government" },
  { text: "Other" },
  { text: "Political" },
  { text: "State-Controlled Media", value: "state-controlled media" },
]);

export const SOURCE_METADATA_RELIABILITY = formatSourceMetadata([
  { text: "High" },
  { text: "Medium" },
  { text: "Low" },
  { text: "Unrated" },
]);

export const SOURCE_METADATA_PLATFORM = formatSourceMetadata([
  { value: "news", text: "News" },
  //Social
  { value: "4chan", text: "4chan" },
  { value: "8kun", text: "8kun" },
  { value: "bilibili", text: "Bilibili" },
  { value: "bluesky", text: "Bluesky" },
  { value: "discord", text: "Discord" },
  { value: "douyin", text: "Douyin" },
  { value: "facebook", text: "Facebook" },
  { value: "gab", text: "Gab" },
  { value: "instagram", text: "Instagram" },
  { value: "reddit", text: "Reddit" },
  { value: "rumble", text: "Rumble" },
  { value: "telegram", text: "Telegram" },
  { value: "threads", text: "Threads" },
  { value: "tiktok", text: "TikTok" },
  { value: "toutiao", text: "Toutiao" },
  { value: "truth social", text: "Truth Social" },
  { value: "vk", text: "VK" },
  { value: "weibo", text: "Weibo" },
  { value: "twitter", text: "X" },
  { value: "xigua", text: "Xigua" },
  { value: "youtube", text: "YouTube" },
]);

export const SOURCE_MATADATA_SOCIAL_PLATFORMS = SOURCE_METADATA_PLATFORM.filter(
  (platform) => platform.value !== "news"
);
export const SOURCE_METADATA_SOCIAL_AUTHENTICITY = formatSourceMetadata([
  { text: "Authentic" },
  { text: "Inauthentic" },
  { text: "Untagged" },
]);

export const SOURCE_METADATA_FOLLOWER_COUNT_BRACKETS = formatSourceMetadata([
  { text: "High: >100k", value: "high" },
  { text: "Medium: 10-100k", value: "medium" },
  { text: "Low: <10k", value: "low" },
]);
